export default __webpack_public_path__ + "static/media/vipbet365_receipt.c91dc2eb.jpg";